import React from 'react';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import CrownIcon from "../../assets/images/icons-crown.svg";

/*
 * Quiz title
 * @param props
 * @returns {*}
 * @constructor
 */
const QuizHeader = props => {
    const { quizData, toggleQuizSave } = props;

    return (
        <React.Fragment>
            <div className="label-field">
                <i className={'fa ' + (!quizData?.isSaved ? 'fa-bookmark-o' : 'fa-bookmark')} onClick={toggleQuizSave}/>
                {
                    quizData?.pricing === "PAID" && <img src={CrownIcon} alt="crown icon" className="crownIcon"/>
                }
                <label className="mock">
                    {quizData?.mode.includes('practice') ? quizData?.mode.split('-')[0].toUpperCase() : quizData?.mode.toUpperCase()}
                </label>
            </div>
            <Tooltip placement="top-start" title={quizData?.name} aria-label={quizData?.name}>
                <h4 className="tool-tip">{quizData?.name}</h4>
            </Tooltip>
        </React.Fragment>
    );
};

export default QuizHeader;
